import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { fetchJornada } from "../services/trackingServiceV2";
import JornadaTimeline, { UtmBadges } from "./JornadaTimeline";

// Popup da Jornada do Cliente. O conteúdo (identidade, KPIs, linha do tempo) vive em JornadaTimeline,
// compartilhado com a página /tracking/jornada/:visitorId.

export default function JornadaModal({ visitorId, onClose }) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const overlayRef = useRef(null);

    useEffect(() => {
        if (visitorId) loadData();
    }, [visitorId]);

    async function loadData() {
        setLoading(true);
        try {
            setData(await fetchJornada(visitorId));
        } catch {
            setData(null);
        }
        setLoading(false);
    }

    function handleOverlayClick(e) {
        if (e.target === overlayRef.current) onClose();
    }

    if (!visitorId) return null;

    return (
        <div ref={overlayRef} onClick={handleOverlayClick}
            className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-start justify-center overflow-y-auto p-4 sm:p-8">
            <div className="bg-surface-1 border border-white/[0.08] rounded-xl w-full max-w-3xl my-4 shadow-2xl animate-in">
                <div className="flex items-center justify-between p-4 border-b border-white/[0.08]">
                    <div>
                        <h2 className="text-lg font-bold text-white">Jornada do Cliente</h2>
                        <p className="text-[11px] text-ink-4">Histórico completo da pessoa, em todas as páginas, sem filtro de período.</p>
                    </div>
                    <div className="flex items-center gap-3">
                        <Link to={`/tracking/jornada/${encodeURIComponent(visitorId)}`} className="text-xs text-emerald-400 hover:underline">Abrir página ↗</Link>
                        <button onClick={onClose} className="text-ink-3 hover:text-white text-xl leading-none p-1">✕</button>
                    </div>
                </div>

                {loading && <div className="flex justify-center py-12"><div className="w-8 h-8 border-2 border-emerald-400 border-t-transparent rounded-full animate-spin" /></div>}
                {!loading && !data && <div className="p-6 text-center text-ink-4">Erro ao carregar jornada</div>}
                {!loading && data && (
                    <div className="p-4 max-h-[78vh] overflow-y-auto">
                        <JornadaTimeline data={data} visitorId={visitorId} compact />
                    </div>
                )}
            </div>
        </div>
    );
}

export { UtmBadges };
